import React, { createContext } from 'react';

export const tabsContext = createContext<string | undefined>(undefined);
export const changeTabsContext = createContext<
  React.Dispatch<React.SetStateAction<string>> | undefined
>(undefined);
